import styled from 'styled-components'
import { Container as BaseContainer } from '../../../../components/Container'
import { ImageSlider } from '../../../../components/ImageSlider'
import { Row, Col } from '../../../../components/Ui-Kits/Grid'
import { faHeart as faHeartLight } from '@fortawesome/pro-regular-svg-icons'

import { faHeart } from '@fortawesome/pro-solid-svg-icons'
import { Heading, Paragraph, Text } from '../../../../components/Ui-Kits/Text'
import { BidBox } from './BidBox'
import { ShippingBox } from './ShippingBox'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useParams } from 'react-router'
import { useAppTranslation } from '../../../../i18n/hooks'
import { useTaxonomies } from '../../../../hooks/useTaxonomies'
import { TaxonomyTypes } from '../../../../constants/categories'
import { useEffect, useMemo, useState } from 'react'
import { useWishlistItemExists } from 'hooks/data/useWishlistItemExists'
import { createWishlistItem, removeWishlistItem } from 'cloudFunctions'
import dayjs from 'dayjs'
import { useAlert } from 'hooks/useAlert'
import { useCurrentUser } from 'hooks/useCurrentUser'
import { bool, object } from 'prop-types'
import { ItemDescription } from './ItemDescription'
import { useGetTranslated } from 'hooks/useGetTranslated'
import { ProductSwitcher } from './ProductSwitcher'
import { theme } from 'globalStyles'

export const Item = ({ product, loading, auction }) => {
  const { auctionId, productId } = useParams()
  const { t } = useAppTranslation()
  const materials = useTaxonomies(TaxonomyTypes.MATERIAL)
  const wishlistItemExists = useWishlistItemExists(productId)
  const [wishlistItemExistsState, setWishlistExistsState] = useState(false)
  const getTranslated = useGetTranslated()

  useEffect(() => {
    setWishlistExistsState(wishlistItemExists)
  }, [wishlistItemExists])
  const alert = useAlert()
  const { user } = useCurrentUser()
  const material = useMemo(
    () => materials.find(({ value }) => value == product?.technicalDetails?.material)?.label,
    [materials, product]
  )
  const conditions = useTaxonomies(TaxonomyTypes.CONDITION)
  const condition = useMemo(
    () => conditions.find(({ value }) => value == product?.technicalDetails?.condition)?.label,
    [conditions, product]
  )
  const counries = useTaxonomies(TaxonomyTypes.COUNTRY)
  const country = useMemo(
    () => counries.find(({ value }) => value == product?.technicalDetails?.country)?.label,
    [counries, product]
  )
  const images = useMemo(() => {
    if (!product?.images || !product.images.length) return [product?.featuredImage?.url]

    return [product?.featuredImage?.url, ...product.images.map(({ url }) => url)]
  }, [product?.featuredImage?.url, product?.images])

  const descriptionProps = useMemo(() => {
    const { reference, conditionDescription, size, weight } = product?.technicalDetails || {}

    return {
      reference,
      conditionDescription,
      size,
      weight,
      product,
      country,
      material,
      condition,
      auctionStatus: product?.auctionStatus,
      finalPrice: product?.secondHighestBid,
    }
  }, [product, country, material, condition])

  if (loading) return null

  const bidBoxVisible =
    auction &&
    dayjs().diff(auction.startDatePreBid) >= 0 &&
    dayjs().diff(auction.endDatePreBid) <= 0 &&
    !auction.liveAuctionStartedAt

  return (
    <Container>
      {product && <ProductSwitcher sort={product?.sort} />}
      <Row>
        <Col sm={12} col={7}>
          <ImageSlider images={images} />
          {product && <ItemDescription {...descriptionProps} />}
        </Col>
        <Col smOffset={0} offset={1} col={4} sm={12}>
          <Heading color="primary" mb={0.625} mt={0}>
            {product?.sort + 1 + '. ' + getTranslated(product?.name)}
          </Heading>
          <WishlistWrap
            color="primary"
            size={1}
            mb={2}
            mt={0}
            onClick={() => {
              if (!user) {
                return alert(t('pleaseLogInToProceed'), 'danger')
              }
              setWishlistExistsState(prev => {
                const willExist = !prev

                if (willExist) {
                  createWishlistItem({ itemId: productId, auctionId }).catch(err => {
                    setWishlistExistsState(() => prev)
                    console.error('createWishlistItem failed', err)
                  })
                } else {
                  removeWishlistItem({ itemId: productId }).catch(err => {
                    setWishlistExistsState(() => prev)
                    console.error('removeWishlistItem failed', err)
                  })
                }

                return willExist
              })
            }}
          >
            <Icon icon={wishlistItemExistsState ? faHeart : faHeartLight} />
            <Text color="primary" size={1} mb={0} mt={0}>
              {wishlistItemExistsState ? t('removeFromWishlist') : t('addToWishlist')}
            </Text>
          </WishlistWrap>
          <HiddenMobile mt={2} mb={2}>
            {getTranslated(product?.description)}
          </HiddenMobile>
          {bidBoxVisible && <BidBox auction={auction} />}
          <ShippingBox containerSize={product?.technicalDetails?.shippingContainer} sku={product?.sku} />
        </Col>
      </Row>
      {product && <ItemDescription {...descriptionProps} mobile />}
    </Container>
  )
}

Item.propTypes = {
  product: object,
  auction: object,
  loading: bool,
}

const Container = styled(BaseContainer)`
  @media screen and (min-width: 1200px) {
    max-width: 1200px;
  }
`

const WishlistWrap = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  margin-bottom: 2rem;
  gap: 0.5rem;
`

const Icon = styled(FontAwesomeIcon)`
  font-size: 1.2rem;
  color: var(--color-primary);
`

const HiddenMobile = styled(Paragraph)`
  display: block;

  ${theme.breakpoints.tablet} {
    display: none;
    width: 486px;
  }
`
